var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-googlemapsstatic__wrapper" }, [
    _c("div", { staticClass: "t-margin-1-bottom" }, [
      _c("div", { staticClass: "c-googlemapsstatic__header" }, [
        _c("h2", { staticClass: "text-h4 heading-boarder" }, [
          _vm._v(_vm._s(_vm.heading))
        ]),
        _vm._v(" "),
        _vm.hasLink
          ? _c("a", { attrs: { target: "_blank", href: _vm.googleMapsUrl } }, [
              _vm._v(_vm._s(_vm.linkText))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.hasMap
        ? _c("div", { staticClass: "t-margin--1-top" }, [
            _c(
              "div",
              { staticClass: "c-googlemapsstatic__image c-content-block" },
              [
                _c("img", {
                  staticClass: "t-border-radius-1 t-box-shadow-1",
                  attrs: { src: _vm.imageUrl }
                })
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }